var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"}},[_c('path',{attrs:{"d":"M20.25 11.2498H3.75C3.33579 11.2498 3 11.5855 3 11.9998C3 12.414 3.33579 12.7498 3.75 12.7498H20.25C20.6642 12.7498 21 12.414 21 11.9998C21 11.5855 20.6642 11.2498 20.25 11.2498Z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }